/* ══════════════════════════════════════════════════
   CarVerif — Code Défaut v3.0 — Modern Interactions
   Scroll-reveal, smooth accordion, frosted tabs
   ══════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ══════════════════════════════════════
     Scroll-reveal (IntersectionObserver)
     ══════════════════════════════════════ */
  var sections = document.querySelectorAll('.cd-section');
  if (prefersReducedMotion) {
    sections.forEach(function(s) { s.classList.add('cd-revealed'); });
  } else {
    /* Mark sections for animation only after JS is loaded —
       sections are visible by default so content shows even if JS fails */
    sections.forEach(function(s) { s.classList.add('cd-will-animate'); });
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cd-revealed');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    sections.forEach(function(s) { revealObs.observe(s); });

    /* Fallback: reveal any still-hidden sections after 1.5s
       (ensures crawlers/bots that execute JS but don't scroll still see content) */
    setTimeout(function() {
      document.querySelectorAll('.cd-will-animate:not(.cd-revealed)').forEach(function(s) {
        s.classList.add('cd-revealed');
      });
    }, 1500);
  }

  /* ══════════════════════════════════════
     Header height detection + CSS variable
     ══════════════════════════════════════ */
  var cdPage = document.querySelector('.cd-page');
  function getHeaderHeight() {
    var header = document.querySelector('sticky-header, .section-header, .shopify-section-group-header-group');
    return header ? header.offsetHeight : 0;
  }
  function setStickyOffset() {
    var h = getHeaderHeight();
    if (cdPage) cdPage.style.setProperty('--cd-header-h', h + 'px');
  }
  setStickyOffset();
  window.addEventListener('resize', setStickyOffset);

  /* ══════════════════════════════════════
     Sticky tabs — active state tracking
     ══════════════════════════════════════ */
  var tabs = document.querySelectorAll('.cd-tab[data-tab]');
  var tabBar = document.getElementById('cdTabs');
  var tabSections = [];
  tabs.forEach(function(tab) {
    var id = tab.getAttribute('href');
    var el = document.querySelector(id);
    if (el) tabSections.push({ tab: tab, el: el });
  });

  function getStickyOffset() {
    return getHeaderHeight() + (tabBar ? tabBar.offsetHeight : 48);
  }

  function updateTabs() {
    var current = tabSections[0];
    var scrollY = window.scrollY + getStickyOffset() + 20;
    tabSections.forEach(function(s) {
      if (s.el.offsetTop <= scrollY) current = s;
    });
    tabs.forEach(function(t) { t.classList.remove('cd-tab-active'); });
    if (current) current.tab.classList.add('cd-tab-active');
  }

  var tabTick = false;
  window.addEventListener('scroll', function() {
    if (!tabTick) {
      requestAnimationFrame(function() {
        updateTabs();
        tabTick = false;
      });
      tabTick = true;
    }
  });

  /* ══════════════════════════════════════
     Smooth scroll for tabs + TOC
     ══════════════════════════════════════ */
  var tabsScrollEl = document.getElementById('cdTabsScroll');

  function centerTab(tab) {
    if (!tabsScrollEl) return;
    var scrollLeft = tab.offsetLeft - (tabsScrollEl.clientWidth / 2) + (tab.offsetWidth / 2);
    tabsScrollEl.scrollTo({ left: scrollLeft, behavior: 'smooth' });
  }

  document.querySelectorAll('.cd-tab[data-tab], .cd-toc-item').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var self = this;
      var target = document.querySelector(self.getAttribute('href'));
      if (target) {
        var offset = getStickyOffset() + 8;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        if (self.classList.contains('cd-tab')) {
          centerTab(self);
        }
      }
    });
  });

  /* ══════════════════════════════════════
     Tab overflow fade indicator
     ══════════════════════════════════════ */
  var tabsScroll = document.getElementById('cdTabsScroll');
  var tabsFade = document.getElementById('cdTabsFade');
  if (tabsScroll && tabsFade) {
    function checkTabOverflow() {
      var hasOverflow = tabsScroll.scrollWidth > tabsScroll.clientWidth;
      var atEnd = tabsScroll.scrollLeft + tabsScroll.clientWidth >= tabsScroll.scrollWidth - 2;
      if (hasOverflow && !atEnd) {
        tabsFade.classList.add('cd-visible');
      } else {
        tabsFade.classList.remove('cd-visible');
      }
    }
    tabsScroll.addEventListener('scroll', checkTabOverflow);
    window.addEventListener('resize', checkTabOverflow);
    checkTabOverflow();
  }

  /* ══════════════════════════════════════
     CTA sticky — show/hide + close button
     ══════════════════════════════════════ */
  var cta = document.getElementById('cdCtaSticky');
  var ctaClose = document.getElementById('cdCtaClose');
  var ctaDismissed = false;

  if (cta) {
    window.addEventListener('scroll', function() {
      if (ctaDismissed) return;
      if (window.scrollY > 600) {
        cta.classList.add('cd-cta-visible');
      } else {
        cta.classList.remove('cd-cta-visible');
      }
    });
  }

  if (ctaClose) {
    ctaClose.addEventListener('click', function() {
      ctaDismissed = true;
      cta.classList.remove('cd-cta-visible');
      cta.classList.add('cd-cta-dismissed');
    });
  }

  /* ══════════════════════════════════════
     Smooth accordion for <details> elements
     ══════════════════════════════════════ */
  if (!prefersReducedMotion) {
    document.querySelectorAll('.cd-faq-item, .cd-marque-details').forEach(function(details) {
      var summary = details.querySelector('summary');
      var content = summary.nextElementSibling;
      if (!summary || !content) return;

      summary.addEventListener('click', function(e) {
        e.preventDefault();

        if (details.open) {
          // Closing
          var startHeight = content.offsetHeight;
          content.style.overflow = 'hidden';
          content.style.maxHeight = startHeight + 'px';
          requestAnimationFrame(function() {
            content.style.transition = 'max-height 0.3s ease';
            content.style.maxHeight = '0px';
          });
          content.addEventListener('transitionend', function handler() {
            details.open = false;
            content.style.maxHeight = '';
            content.style.overflow = '';
            content.style.transition = '';
            content.removeEventListener('transitionend', handler);
          });
        } else {
          // Opening
          details.open = true;
          var endHeight = content.offsetHeight;
          content.style.overflow = 'hidden';
          content.style.maxHeight = '0px';
          requestAnimationFrame(function() {
            content.style.transition = 'max-height 0.3s ease';
            content.style.maxHeight = endHeight + 'px';
          });
          content.addEventListener('transitionend', function handler() {
            content.style.maxHeight = '';
            content.style.overflow = '';
            content.style.transition = '';
            content.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

});
